import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

// Pasar a "En revisión" exige un resumen; pasar a "Bloqueada" exige un motivo
// (spec §tablero: "Pasar a 'En revisión' requiere resumen; pasar a 'Bloqueada'
// requiere motivo").
export function MoveReasonDialog({ open, kind, onCancel, onConfirm, loading }) {
  const [text, setText] = useState("");
  const isReview = kind === "in_review";

  // Fix 2026-10-28 (testing iter120): el texto del intento anterior se
  // quedaba pegado al reabrir el diálogo para otra tarea distinta.
  useEffect(() => {
    if (open) setText("");
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent data-testid="task-move-reason-dialog">
        <DialogHeader>
          <DialogTitle>{isReview ? "Resumen para revisión" : "Motivo del bloqueo"}</DialogTitle>
        </DialogHeader>
        <Textarea
          autoFocus
          placeholder={isReview ? "¿Qué se ha hecho? ¿Qué hay que revisar?" : "¿Por qué está bloqueada esta tarea?"}
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          data-testid="task-move-reason-input"
        />
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} data-testid="task-move-reason-cancel">Cancelar</Button>
          <Button
            onClick={() => onConfirm(text)}
            disabled={!text.trim() || loading}
            data-testid="task-move-reason-confirm"
          >
            {loading ? "Guardando..." : "Confirmar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
